import { getShouldUseCSPhone } from '../growthbook';

export const formatNumber = (num) => {
  const numStr = num.toString();
  const reversed = numStr.split('').reverse();
  const parts = [];

  for (let i = 0; i < reversed.length; i += 3) {
    parts.push(reversed.slice(i, i + 3).join(''));
  }

  return parts.join(',').split('').reverse().join('').replace(/-,/g, '-');
};

/**
 * @param phone +18558794688
 * @param style traditional | simplified
 * @returns traditional: (855) 879-4688
 * @returns simplified: 855-879-4688
 */
export const formatUSPhoneNumber = (phone, style) => {
  const cleaned = phone.replace(/\D/g, ''); // Remove non-digit characters
  const match = cleaned.match(/^1?(\d{3})(\d{3})(\d{4})$/); // Optional country code +1
  if (match) {
    const [, areaCode, centralOffice, lineNumber] = match;

    if (style === 'traditional') {
      return `(${areaCode}) ${centralOffice}-${lineNumber}`;
    }

    return `${areaCode}-${centralOffice}-${lineNumber}`;
  }

  return phone; // Return original if it doesn't match pattern
};

export const getCSPhone = () => {
  const defaultPhoneNumber = '+17864602170';
  const phone = getShouldUseCSPhone?.() ?? defaultPhoneNumber;

  return {
    formatted: formatUSPhoneNumber(phone, 'traditional'),
    formattedSimplified: formatUSPhoneNumber(phone, 'simplified'),
    default: phone,
  };
};
